<p-dialog
  class="filters-modal exchange-rate-calculator-modal add-exchange-rate"
  header="Cotiza tu exchange"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '640px', maxWidth: 'calc(100vw - 32px)' }"
  *ngIf="visible"
  (visibleChange)="closeCalculatorModal()"
>
  <div
    class="screen-container tasador-screen"
    [class.minimized]="appService.minimized"
  >
    <div class="content-container tasador-page">
      <!-- Hero verde -->
      <header class="tasador-hero">
        <p class="tasador-hero__subtitle">
          Elige monedas y monto para obtener la tasa y lo que recibes al
          concretar tu exchange.
        </p>
      </header>

      <!-- Card blanca -->
      <div class="tasador-card">
        <div class="loading-coins" *ngIf="loadingCoins">
          <app-loading [loadingText]="'Cargando monedas'" />
        </div>

        <div *ngIf="!loadingCoins" class="tasador-card__inner">
          <div class="tasador-card__badge" *ngIf="quoteResult && !quoteError">
            <i class="pi pi-lock"></i>
            <span>Tasa cotizada</span>
          </div>

          <form [formGroup]="quoteForm" class="tasador-form">
            <!-- Envías exactamente -->
            <div class="tasador-block">
              <label class="tasador-block__label">Envías exactamente</label>
              <div class="tasador-block__row">
                <div class="tasador-block__currency">
                  <p-dropdown
                    formControlName="source_currency"
                    [options]="getSourceOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Moneda"
                    [filter]="true"
                    filterBy="label"
                    appendTo="body"
                    styleClass="tasador-dropdown tasador-dropdown--compact"
                  />
                </div>
                <p-inputNumber
                  formControlName="amount_send"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  placeholder="0.00"
                  mode="decimal"
                  [min]="0"
                  class="tasador-input--amount"
                  [styleClass]="
                    'tasador-input tasador-input--amount' +
                    (hasInsufficientSourceBalance
                      ? ' tasador-input--invalid'
                      : '')
                  "
                />
              </div>
              <p
                class="tasador-balance-warning"
                *ngIf="hasInsufficientSourceBalance"
              >
                <i class="pi pi-exclamation-triangle"></i>
                <span>{{ sourceBalanceErrorMessage }}</span>
              </p>
            </div>

            <!-- Botón swap monedas -->
            <div class="tasador-swap-row">
              <button
                type="button"
                class="tasador-swap-btn"
                [disabled]="
                  !quoteForm.get('source_currency')?.value ||
                  !quoteForm.get('target_currency')?.value
                "
                (click)="swapCurrencies()"
                pTooltip="Intercambiar monedas"
                tooltipPosition="left"
                aria-label="Intercambiar monedas de envío y recepción"
              >
                <svg
                  class="tasador-swap-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="M12 19V5M12 5L8 9M12 5L16 9" />
                  <path d="M12 5V19M12 19L8 15M12 19L16 15" />
                </svg>
              </button>
            </div>

            <!-- El destinatario recibe -->
            <div class="tasador-block">
              <label class="tasador-block__label">Recibes</label>
              <div class="tasador-block__row">
                <div class="tasador-block__currency">
                  <p-dropdown
                    formControlName="target_currency"
                    [options]="getTargetOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Moneda"
                    [filter]="true"
                    filterBy="label"
                    appendTo="body"
                    styleClass="tasador-dropdown tasador-dropdown--compact"
                  />
                </div>
                <div
                  class="tasador-block__amount tasador-block__amount--result"
                  [class.has-value]="displayRecipientAmount != null"
                >
                  <span
                    *ngIf="displayRecipientAmount != null"
                    class="tasador-amount-result"
                    >{{ displayRecipientAmount }}</span
                  >
                  <span
                    *ngIf="displayRecipientAmount == null && !loadingQuote"
                    class="tasador-amount-placeholder"
                    >—</span
                  >
                  <span *ngIf="loadingQuote" class="tasador-amount-loading"
                    ><i class="pi pi-spin pi-spinner"></i
                  ></span>
                </div>
              </div>
              <p
                class="tasador-block__hint"
                *ngIf="
                  quoteResult && quoteResult.amount_send == null && !quoteError
                "
              >
                Ingresa un monto arriba y pulsa Cotizar para ver el resultado.
              </p>
            </div>

            <!-- Detalles: tasa, on-ramp/off-ramp del usuario, comisión calculada, total a pagar -->
            <div class="tasador-details" *ngIf="quoteResult && !quoteError">
              <div class="tasador-details__item">
                <i class="pi pi-arrow-right-arrow-left"></i>
                <span class="tasador-details__label">Tasa</span>
                <span class="tasador-details__value"
                  >1 {{ quoteResult.source_currency }} =
                  {{ quoteResult.rate | number: "1.2-8" }}
                  {{ quoteResult.target_currency }}</span
                >
              </div>
              <div
                class="tasador-details__item"
                *ngIf="hasFeeConfig(quoteResult.fee_on_ramp)"
              >
                <i class="pi pi-arrow-up-right"></i>
                <span class="tasador-details__label"
                  >On-ramp (envío {{ quoteResult.source_currency }})</span
                >
                <span class="tasador-details__value">{{
                  formatFeeDisplay(quoteResult.fee_on_ramp)
                }}</span>
              </div>
              <div
                class="tasador-details__item"
                *ngIf="hasFeeConfig(quoteResult.fee_off_ramp)"
              >
                <i class="pi pi-arrow-down-left"></i>
                <span class="tasador-details__label"
                  >Off-ramp (recepción {{ quoteResult.target_currency }})</span
                >
                <span class="tasador-details__value">{{
                  formatFeeDisplay(quoteResult.fee_off_ramp)
                }}</span>
              </div>
              <div class="tasador-details__item" *ngIf="subtotalAmount != null">
                <i class="pi pi-calculator"></i>
                <span class="tasador-details__label">Subtotal</span>
                <span class="tasador-details__value"
                  >{{ subtotalAmount | number: "1.2-8" }}
                  {{ quoteResult.source_currency }}</span
                >
              </div>
              <div class="tasador-details__item" *ngIf="fixedFeeAmount != null">
                <i class="pi pi-tag"></i>
                <span class="tasador-details__label">Comisión</span>
                <span class="tasador-details__value"
                  >{{ fixedFeeAmount | number: "1.2-8" }}
                  {{ quoteResult.source_currency }}</span
                >
              </div>
              <div
                class="tasador-details__item tasador-details__item--total"
                *ngIf="quoteAmountSend != null"
              >
                <i class="pi pi-money-bill"></i>
                <span class="tasador-details__label">Total a pagar</span>
                <span class="tasador-details__value"
                  >{{ quoteAmountSend | number: "1.2-8" }}
                  {{ quoteResult.source_currency }}</span
                >
              </div>
            </div>

            <!-- Error -->
            <div
              *ngIf="quoteError"
              class="tasador-message tasador-message--error"
            >
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ quoteError }}</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons-container">
    <p-button
      label="Cotizar"
      icon="pi pi-calculator"
      [loading]="loadingQuote"
      [disabled]="
        quoteForm.invalid ||
        loadingQuote ||
        creatingExchange ||
        hasInsufficientSourceBalance
      "
      severity="secondary"
      (click)="onSubmit()"
    />
    <div
      class="tasador-create-exchange"
      *ngIf="hasValidQuoteForExchange && canExecuteExchange"
    >
      <p-button
        label="Crear exchange"
        icon="pi pi-check"
        [loading]="creatingExchange"
        [disabled]="creatingExchange || loadingQuote || !canCreateExchange"
        styleClass="tasador-btn-primary"
        [pTooltip]="createExchangeDisabledTooltip"
        tooltipPosition="top"
        (click)="createExchange()"
      />
      <div class="tasador-rate-expiration" *ngIf="showRateExpirationBar">
        <div class="tasador-rate-expiration__track">
          <div
            class="tasador-rate-expiration__bar"
            [style.width.%]="rateExpirationProgressPercent"
            [class.tasador-rate-expiration__bar--expired]="isQuoteExpired"
          ></div>
        </div>
        <span class="tasador-rate-expiration__label">
          {{ isQuoteExpired ? 'Tasa expirada' : rateExpirationSecondsLeft + 's' }}
        </span>
      </div>
      <p class="tasador-rate-expiration__message" *ngIf="isQuoteExpired">
        Tasa expirada, consulta de nuevo.
      </p>
    </div>
  </div>
</p-dialog>
